module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue),
      expression: "localValue"
    }],
    staticClass: "search__input",
    class: {
      'viewOnly': _vm.locked
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.localValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('svg-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearchInputEmpty),
      expression: "isSearchInputEmpty"
    }],
    staticClass: "search__search-icon",
    attrs: {
      "icon": _vm.searchIcon,
      "width": 14,
      "height": 14
    }
  }), _vm._v(" "), _c('svg-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSearchInputEmpty),
      expression: "!isSearchInputEmpty"
    }],
    staticClass: "search__cancel-icon",
    attrs: {
      "icon": _vm.cancelIcon,
      "width": 10,
      "height": 10
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearSearch.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28660327"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/searchInput/SearchInput.vue
// module id = 1846
// module chunks = 0